import { Check, View } from "lucide-react";
import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { CustomProperty } from "winslow-core";
import { AppCustomPropertyError } from "./AppCustomPropertyError";


type AppCustomPropertyDateProps = {
    customProperty: CustomProperty;
    data: any;
    disabled: boolean;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyDate = ({customProperty, data, disabled, validate, onChange} : AppCustomPropertyDateProps) => {

    const [date, setDate] = useState<Date | null>(data ? new Date(data) : null);

    useEffect(() => {
        if (data) {
            setDate(new Date(data));
        } else {
            setDate(null);
        }
    }, [data]);

    useEffect(() => {
        onChange(customProperty.label, date);
    }, [date]);

    // console.log("[AppCustomPropertyDate] date: ", date);

    return (
        <div className="app-custom-property-date">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value">
               
                <DatePicker
                    selected={date} 
                    dateFormat={"MM/dd/yyyy"}
                    disabled={disabled}
                    onChange={(date) => {
                        console.log("DatePicker date", date);
                        setDate(date as Date | null);
                        onChange(customProperty.label, date);
                    }}
                    className="date-picker-input"
                    wrapperClassName="app-date-picker-wrapper"
                />
                <AppCustomPropertyError 
                    flagRequired={validate && !date && customProperty.required}
                />
                
                {/* {validate && !date && customProperty.required &&
                   <AppCustomPropertyError />
                } */}
            </div>
        </div>
    )
}
